import { useRef } from 'react';
import { DAYS_SHORT } from '../../../../constants';
import { getWeekDays } from '../../../../utils';

export default function WeekView({ selectedDate, onSelectDate }) {
    const weekDays = getWeekDays(selectedDate);
    const selectedRef = useRef(null);
    return (
        <div className="week-strip-container">
            <button
                onClick={() => { const d = new Date(selectedDate); d.setDate(d.getDate() - 7); onSelectDate(d); }}
                className="nav-btn prev"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <div className="days-container">
                {weekDays.map((d, i) => {
                    console.log(d, selectedDate);

                    const isSelected = d.toDateString() === selectedDate.toDateString();
                    console.log(isSelected, i);
                    if (isSelected) {
                        selectedRef.current = d;
                    }

                    return (
                        <button
                            key={i}
                            onClick={() => onSelectDate(d)}
                            ref={isSelected ? selectedRef : null}
                            className={`day-btn ${isSelected ? 'selected' : ''}`}
                        >
                            <span className="day-name">{DAYS_SHORT[d.getDay()]}</span>
                            <span className={`day-number ${isSelected ? 'selected' : ''}`}>{d.getDate()}</span>
                        </button>
                    );
                })}
            </div>
            <button
                onClick={() => { const d = new Date(selectedDate); d.setDate(d.getDate() + 7); onSelectDate(d); }}
                className="nav-btn next"
            >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>
    );
}
